<template>
  <div class="bar">
    <transition name="fade">
      <button v-if="showTop" class="item" type="button" title="返回顶部" @click="scrollTop">↑</button>
    </transition>

    <a class="item" href="tel:13958349372" title="电话咨询：13958349372">☎</a>
    <a class="item" href="mailto:17371988805@163.com" title="邮箱：17371988805@163.com">✉</a>

    <div class="wechat-item">
      <button class="item" type="button" title="微信：13958349372">💬</button>
      <div class="wechat-tip">
        <div class="tip-title">官方微信</div>
        <div class="tip-desc">13958349372<br />工作日 8:30-17:30 在线</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from "vue";

const showTop = ref(false);

function onScroll() {
  showTop.value = window.scrollY > 400;
}

function scrollTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

onMounted(() => {
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", onScroll);
});
</script>

<style scoped>
.bar {
  position: fixed;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 60;
}

.item {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  border: 1px solid #e3e9f1;
  background: rgba(255, 255, 255, 0.94);
  cursor: pointer;
  font-size: 18px;
  box-shadow: 0 8px 20px rgba(10, 79, 151, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s, box-shadow 0.2s, background 0.2s;
}

.item:hover {
  transform: translateX(-3px);
  background: #eef5fd;
  box-shadow: 0 12px 24px rgba(10, 79, 151, 0.16);
}

/* 微信弹层 */
.wechat-item {
  position: relative;
}

.wechat-tip {
  position: absolute;
  right: calc(100% + 14px);
  top: 50%;
  transform: translateY(-50%) translateX(6px);
  width: 200px;
  background: #fff;
  border: 1px solid #e3e9f1;
  border-radius: 12px;
  padding: 14px 16px;
  box-shadow: 0 16px 36px rgba(16, 42, 67, 0.14);
  opacity: 0;
  visibility: hidden;
  transition: all 0.22s ease;
  text-align: center;
}

.wechat-item:hover .wechat-tip {
  opacity: 1;
  visibility: visible;
  transform: translateY(-50%) translateX(0);
}

.tip-title {
  font-size: 14px;
  font-weight: 800;
  color: #0a4f97;
}

.tip-desc {
  margin-top: 8px;
  font-size: 12.5px;
  line-height: 1.7;
  color: #5b6b7e;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(6px);
}

@media (max-width: 768px) {
  .bar {
    right: 10px;
  }

  .item {
    width: 40px;
    height: 40px;
  }
}
</style>
